import { Component, Input, OnChanges, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { RenderableFieldInterface } from '../../tokens-and-interfaces';

@Component({
  selector: 'crm-renderer-selector',
  template: '<ng-container></ng-container>',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class RendererSelectorComponent implements OnInit, OnChanges {
  @Input() handler!: RenderableFieldInterface;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnInit(): void {
    this.handler?.render(this.viewContainerRef);
  }

  ngOnChanges(): void {
    this.handler?.render(this.viewContainerRef);
  }
}
